import {useState} from 'react';
import * as Yup from 'yup';
import {Formik, Form} from 'formik';
import {useParams, useNavigate} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';

import CustomRadio from '../../../components/mazraeKit/customRadio';
import FormikTextArea from '../../../components/formikFileds/textArea';
import CustomHeader from '../../../components/mazraeKit/headers/homeHeader';
import {addViolation, resetViloation} from '../../../store/redux/violation';
import {RootState} from '../../../store/redux';
import {usePostViolationReportStore} from '../../../services/hookService/postViolationReportstore/usePostViolationReortStore';
import useGetViolationReason from '../../../services/hookService/getViolationReason/getViolationReason';
import ShowViolationModal from './modal/showViolationModal';
import DotsLoading from '../../../components/dotsLoading';

const ViolationReportStore = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {store_guid} = useParams();
  const state = useSelector((state: RootState) => state.violationStore);
  const [showViolationModal, setShowViolationModal] = useState(false);

  const [touched, setTouched] = useState(false);

  const onSuccess = () => {
    setShowViolationModal(true);
    dispatch(resetViloation({}));
  };

  const {mutate, isLoading} = usePostViolationReportStore({onSuccess});
  const {violationReasons} = useGetViolationReason({type: 'store'});

  const violationSchema = Yup.object().shape({
    description: Yup.string().required('توضیحات را وارد کنید.'),
    reason_report_guid: Yup.string().required('یک مورد را انتخاب کنید.'),
  });

  return (
    <div className="flex flex-col h-full">
      <CustomHeader
        title="گزارش تخلف"
        preIcon="icon-nameArrow---Right"
        isActiveRightIcon
        onClick={() => {
          if (!state.description) {
            navigate(-1);
            dispatch(resetViloation({}));
          } else {
            dispatch(resetViloation({}));
          }
        }}
      />

      <Formik
        initialValues={{description: '', reason_report_guid: ''}}
        validationSchema={violationSchema}
        onSubmit={values => {
          if (store_guid) {
            const payload = {
              description: values.description,
              Reason_report_guid: values.reason_report_guid,
              store_guid: store_guid,
            };
            mutate(payload);
          }
        }}
      >
        {({values, errors, setFieldValue}) => {
          return (
            <Form className="flex flex-col mt-6 h-full">
              {state.reason_report_guid ? (
                <div className="flex h-full flex-col ">
                  <div className="flex flex-col h-full px-6">
                    <p>
                      <span className="text-sm">دلیل گزارش را توضیح دهید.</span>
                      <span className="text-sm text-red-600">*</span>
                    </p>
                    <FormikTextArea
                      name="description"
                      label=""
                      rows={4}
                      placeholder="متن گزارش (اجباری) "
                      touched={touched}
                    />
                  </div>
                  <div className="px-6 py-2 rounded-t-md shadow-dropShadow">
                    <button
                      className="w-full h-12 rounded bg-farm-shop-500 text-white"
                      onClick={() => {
                        setTouched(true);
                        dispatch(addViolation({...state, ...values}));
                      }}
                    >
                      ثبت گزارش
                    </button>
                  </div>
                </div>
              ) : (
                <div className="flex h-full flex-col ">
                  <div className="flex flex-col h-full px-6">
                    <p className="text-sm text-Medium">
                      دلیل گزارش را انتخاب کنید.
                      <span className="text-red-600">*</span>
                    </p>
                    <span className="text-sm text-gray-700 mb-4">
                      گزارش شما جهت حفظ حریم خصوصی، محفوظ باقی می‌ماند.
                    </span>
                    {isLoading ? (
                      <div className="flex justify-center items-center">
                        <DotsLoading />
                      </div>
                    ) : (
                      <div className="flex flex-col gap-3">
                        {violationReasons &&
                          violationReasons?.map(item => (
                            <CustomRadio
                              customClassName="text-gray-900"
                              title={item.title}
                              name="reason_report_guid"
                              value=""
                              onChange={() =>
                                setFieldValue('reason_report_guid', item.guid)
                              }
                            />
                          ))}
                      </div>
                    )}
                    {errors.reason_report_guid && touched && (
                      <span className="text-red-400 text-sm mt-4">
                        {errors.reason_report_guid}
                      </span>
                    )}
                  </div>
                  <div className="flex px-6 py-2 rounded-t-md shadow-dropShadow justify-end">
                    <button
                      className="px-14 h-12 rounded bg-farm-shop-500 text-white"
                      onClick={() => {
                        setTouched(true);
                        dispatch(addViolation({...state, ...values}));
                      }}
                    >
                      بعدی
                    </button>
                  </div>
                </div>
              )}
            </Form>
          );
        }}
      </Formik>
      <ShowViolationModal
        isSuccessModal={showViolationModal}
        setIsSuccessModal={setShowViolationModal}
      />
    </div>
  );
};

export default ViolationReportStore;
